import { t } from "../../../hooks/useAppTranslation";
import {useState} from 'react';

import {errorMessageText} from '../../HttpService/HttpService';
import PopUp from '../../PopUp/PopUp';
import {UploadDocuments, UploadFiles} from '..';
import {bannedExtenstions} from '../UploadFiles/UploadFiles'

export const AddDocuments = ({controlUuid, onClose, saveAsDraft}) => {
  const [errorPopupData, setErrorPopupData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [popUpDisabled, setPopUpDisabled] = useState(false);

  function handleUploadError(error, response) {
	  if(error === 413) {
		  setErrorPopupData({
			  title: t('g-files-upload-error'),
			  notification: t('g-invalid-file-size'),
			  type: 'error',
			  closePopUp: () => setErrorPopupData(false),
		  });
    } else if(error === 415) {
		  setErrorPopupData({
			  title: t('g-files-upload-error'),
			  notification: `${t('g-invalid-extension')} ${bannedExtenstions.join(', ')}`,
			  type: 'error',
			  closePopUp: () => setErrorPopupData(false),
		  });
	  }else {
		  setErrorPopupData({
			  title: t('g-files-upload-error'),
			  notification: `${t('g-failed-add-file')} ${errorMessageText(response?.status)}`,
			  type: 'error',
			  closePopUp: () => setErrorPopupData(false),
		  });
	  }
  }

  function handleUploadSuccess(fileList) {
    setUploadedFiles(fileList);
  }

  function handleClose(documentsUploaded) {
    onClose(documentsUploaded || []);
  }

  return (
    <>
      <PopUp
        customContent
        title={t('external-controls-adding-file')}
        handleClosePopup={popUpDisabled ? () => {} : () => handleClose([])}
      >
        {uploadedFiles.length > 0
          ? <UploadDocuments
              controlUuid={controlUuid}
              setPopUpDisabled={setPopUpDisabled}
              uploadedFiles={uploadedFiles}
              onClose={handleClose}
              saveAsDraft={saveAsDraft}
            />
          : (
            <>
              <UploadFiles
                  errorCallback={handleUploadError}
                  setPopUpDisabled={setPopUpDisabled}
                  successCallback={handleUploadSuccess}
              />
              {errorPopupData && <PopUp {...errorPopupData} />}
            </>
            )
        }
      </PopUp>
    </>
  )
};
